import { z } from 'zod';

export const CrearMensajeLicitacionRequestSchema = z.object({
  mensaje: z.string().min(1, 'El mensaje no puede estar vacío')
});

export const CrearMensajeLicitacionResponseSchema = z.object({
  fecha_creacion: z.string(),
  mensaje: z.string(),
  licitacion_id: z.number(),
  usuario_autor: z.string(),
  fecha_actualizacion: z.string().nullable(),
  id: z.string(),
  activo: z.boolean()
});

export type CrearMensajeLicitacionRequest = z.infer<typeof CrearMensajeLicitacionRequestSchema>;
export type CrearMensajeLicitacionResponse = z.infer<typeof CrearMensajeLicitacionResponseSchema>; 